import { render } from "./add-identification.vue?vue&type=template&id=40a4dc58&scoped=true"
import script from "./add-identification.vue?vue&type=script&lang=js"
export * from "./add-identification.vue?vue&type=script&lang=js"

import "./add-identification.vue?vue&type=style&index=0&id=40a4dc58&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a4dc58"]])

export default __exports__